<template>
  <div class="container">
    <div class="row">
      <div class="col-sm">
        <div class="kurs-home-discreption">
        <h1>Training für moderne Kataraktchirurgie</h1>
        <p>
          <label>
            <b>Die Zimmermann Akademie bietet praxisorientierte Kurse für Ärzte, die ihre chirurgischen Fähigkeiten in der Kataraktchirurgie gezielt verbessern möchten. Unsere Trainings kombinieren modernste Simulationstechnologie mit praktischem Wetlab-Training.</b>
          </label>
        </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <div class="kurs-home-discreption">
          <h2>Phako Wetlab Training</h2>
          <p>
            <label>
              Im Wetlab trainieren Teilnehmer die praktischen Schritte der Kataraktoperation unter Anleitung erfahrener Operateure.
            </label>
          </p>
          <p>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">Hornhautinzision und Capsulorhexis</li>
              <li class="list-group-item">Hydrodissektion und Phakoemulsifikation</li>
              <li class="list-group-item">Cortex-Aspiration und IOL-Implantation</li>
              <li class="list-group-item">Tipps aus der chirurgischen Praxis</li>
            </ul>
          </p>
          <p>
            👨‍⚕️ Kleine Gruppen – intensives chirurgisches Training
          </p>
          <p>
            ⏱ Kursdauer: ca. 5 Stunden
          </p>
          <p>___</p>
          <p>
            Jetzt Kursplatz sichern
          </p>
          <button class="btn btn-light" v-on:click="goToPakoCourses('Phako')">Anmelden</button>
        </div>
      </div>
      <div class="col-sm">
        <div class="kurs-home-discreption">
          <h2>Eyesi Surgical Simulator</h2>
          <p>
            <label>
              <p>Trainieren Sie die Kataraktchirurgie in einer realistischen virtuellen Operationsumgebung.</p>
              <p>Der Eyesi Simulator ermöglicht es, operative Schritte der Phakoemulsifikation sicher zu üben und chirurgische Präzision zu entwickeln.</p>
            </label>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">Realistische Kataraktoperation-Simulation</li>
              <li class="list-group-item">Training von Capsulorhexis und Phako-Techniken</li>
              <li class="list-group-item">Kontrolle von Fluidik und Fußpedal</li>
              <li class="list-group-item">Komplikationen sicher üben</li>
            </ul>
          </p>
          <button class="btn btn-light" v-on:click="goToPakoCourses('Simulator')">Anmelden</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <div class="kurs-home-discreption">
          <h2>Zimmermann Akademie – Hospitationsprogramm Augenheilkunde</h2>
          <p>
            <label>
              Erlernen Sie praxisnah die moderne Augenheilkunde in einem strukturierten 2-Monats-Programm.
            </label>
          </p>
          <div class="row">
            <div class="col-sm-3">
              <h3>Inhalte</h3>
            </div>
            <div class="col-sm">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">Spaltlampenuntersuchung</li>
                <li class="list-group-item">OCT & Diagnostik</li>
                <li class="list-group-item">Katarakt-OP (Beobachtung)</li>
                <li class="list-group-item">Wetlab (Phako-Training)</li>
                <li class="list-group-item">spaltlampsimulator</li>
              </ul>
            </div>
          </div>
          <label></label>
          <div class="row">
            <div class="col-sm-3">
              <h3>Ablauf</h3>
            </div>
            <div class="col-sm">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">Dauer: 2 Monate</li>
                <li class="list-group-item">Kombination aus Theorie, Praxis & Simulation</li>
                <li class="list-group-item">Individuelle Betreuung</li>
              </ul>
            </div>
          </div>
          <label></label>
          <div class="row">
            <div class="col-sm-3">
              <h3>Zielgruppe</h3>
            </div>
            <div class="col-sm">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">Assistenzärzte</li>
                <li class="list-group-item">Internationale Kollegen </li>
              </ul>
            </div>
          </div>
          <label></label>
          <div class="row">
            <div class="col-sm-3">
              <h3>Teilnahmegebühr</h3>
            </div>
            <div class="col-sm">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">1.000 € pro Monat mit MwSt</li>
              </ul>
            </div>
          </div>
          <label></label>
          <div class="row">
            <div class="col-sm-3">
              <h3>Besonderheiten</h3>
            </div>
            <div class="col-sm">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">Praxisnahes Training</li>
                <li class="list-group-item">Moderne Geräte</li>
                <li class="list-group-item">Strukturierte Ausbildung</li>
              </ul>
            </div>
          </div>
          <label></label>
          <div class="row">
            <div class="col-sm-3">
              <h3>📩 Anmeldung unter:</h3>
            </div>
            <div class="col-sm">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                    <a href="mailto:mvz.zimmermann@web.de">mvz.zimmermann@web.de</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import 'bootstrap-vue/dist/bootstrap-vue.css'

@Component({
})
export default class KurseHome extends Vue {
  goToPakoCourses (courseNameToGo:string) {
    if (courseNameToGo === 'Phako') {
      this.$router.push({
        name: 'appointments_by_course',
        params: { courseName: courseNameToGo }
      })
    } else if (courseNameToGo === 'Simulator') {
      this.$router.push({
        name: 'appointments_of_simulator',
        params: { courseName: courseNameToGo }
      })
    }
  }
}
</script>

<style scoped>

.kurs-home-discreption {
  background: #018CCDFF;
  color: #ffffff;
  padding: 10px;
  margin: 20px;
}

</style>
